import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/revenda-iptv")({
  component: () => <Outlet />,
});
